<template>
    <div class="content-leftright">
        <div class="content-leftright-itens">
            <div class="container">
                <div class="content-leftright-itens-text">
                    <div>
                        <h1 class="v-content-client-leftright" v-contentClientLeftRight="{ section: 'Left Right Sections', removeHtml: true }">O freebee® é o maior programa de fidelização multimarca integrado nos PDVs - cliente</h1>
                        <p class="v-content-client-leftright" v-contentClientLeftRight="{ section: 'Left Right Sections', removeHtml: true }">- Integração da marca num ecossistema já existente - cliente<br>
                        - Presença a nível nacional - cliente<br>
                        - Interação com os clientes numa lógica omnicanal
                        (POS, Web, Apps)- cliente<br>
                        - Destaque  e comunicação de novidades e campanhas de forma automática e imediata- cliente <br>
                        - Ativação One Click and Go- cliente
                        </p>
                    </div>
                </div>
            </div>
            <div class="content-leftright-itens-img">
                <img src="@/assets/img/client/section1.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import store from "@/store";

const allContents = [];
const lang = localStorage.getItem('locale') || 'es';

export default {
  name: "Banner",
  data() {
    return {};
  },
  methods: {
    updateDirectives() {
      const allElements = document.querySelectorAll('.v-content-client-leftright');
      allContents.splice(0, allContents.length); // clear the contents array
      allElements.forEach((el) => {
          const params = el.dataset.params ? JSON.parse(el.dataset.params) : {};
          params.content = el.innerHTML.trim();
          (!('type' in params) ? params.type = 'text' : null);
          params.theme = process.env.VUE_APP_THEME;
          params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
          allContents.push(params);
      });
    },
  },
created() {
    this.updateDirectives();
},
  directives: {
      contentClientLeftRight: {
        inserted: async function (el, binding) {
          const allElements = document.querySelectorAll('.v-content-client-leftright');
          let params = binding.value ? binding.value : {};
          params.content = el.innerHTML.trim();
          (!('type' in params) ? params.type = 'text' : null);
          params.theme = process.env.VUE_APP_THEME;
          params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
          allContents.push(params);
  
          if (allElements.length == allContents.length) {
            store.dispatch('App/loading', true);
            await axios({
              method: "POST",
              url: '/api/v1/site/get-all-contents',
              data: { allContents, lang }
            })
              .then(response => response.data)
              .then((data) => {
  
                const allElements = document.querySelectorAll('.v-content-client-leftright');
                allContents.forEach((el) => {
                  if (el.type == 'text') {
                    allElements.forEach((el, index) => {
                      el.innerHTML = data.data[index];
                    });
                  }
                });
                store.dispatch('App/loading', false);
              });
          }
        },
  
      }
    },
};
</script>

<style lang="scss">
.content-leftright {
    margin: 85px 0;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 70px;

    &-itens {
        width: 100%;
        height: auto;
        min-height: 800px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        position: relative;
        @media screen and (max-width: 1400px) {
            min-height: 570px;
        }
        @media screen and (max-width: 1200px) {
            min-height: 500px;
        }
        &:nth-child(even) {
            flex-direction: row-reverse;
            @media screen and (max-width: 991px) {
                flex-direction: column;
            }

            .content-leftright-itens-text {
                justify-content: flex-end;
                div {
                    justify-content: flex-end;
                }
            }

            .content-leftright-itens-img {
                right: auto;
                left: 0;
            }
        }
        @media screen and (max-width: 991px) {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 30px;
            min-height: auto;
        }

        &-text {
            width: 100%;
            height: auto;
            display: flex;
            align-items: center;
            text-align: left;
            justify-content: flex-start;
            z-index: 1;
            div {
                width: 812px;
                max-width: 50%;
                height: auto;
                display: flex;
                flex-direction: column;
                justify-content: center;
                @media screen and (max-width: 991px) {
                    width: 100%;
                    max-width: 100%;
                }
                h1 {
                    font-family: 'Font Bold';
                    font-size: 45px;
                    line-height: 60px;
                    color: var(--main-color);
                    margin-bottom: 25px;
                    @media screen and (max-width: 1400px) {
                        font-size: 35px;
                        line-height: 45px;
                    }
                    @media screen and (max-width: 991px) {
                        font-size: 25px;
                        line-height: 35px;
                    }
                }

                p {
                    font-family: 'Font Regular';
                    font-size: 24px;
                    line-height: 44px;
                    color: var(--gray);
                    @media screen and (max-width: 1400px) {
                        font-size: 20px;
                        line-height: 30px;
                    }
                    @media screen and (max-width: 991px) {
                        font-size: 16px;
                        line-height: 36px;
                    }
                }
            }
        }
    }

    &-itens-img {
        position: absolute;
        top: 0;
        bottom: 0;
        left: auto;
        max-width: 50%;
        display: flex;
        align-items: center;
        &:nth-child(even) {
            right: 0;
            left: auto;
        }

        img {
            width: 100%;
            height: auto;
        }
        @media screen and (max-width: 991px) {
            position: relative;
            max-width: 100%;
            height: auto;
            img {
                width: 100%;
                height: auto;
            }
            
        }
    }
}
</style>



